import { QueryParamsBase } from "@/types/types";

export function isBaseQueryParams(params?: QueryParamsBase): boolean {
  return (
    Object.keys(params?.filters || {}).length === 0 && // sin filtros
    (params?.order ?? null) === null // sin orden
  );
}